<div class="flex flex-col h-full min-h-0">
  <elcia-title [title]="contactName() || ('entity.contact' | translate)" [iconType]="'user'"/>

  <elcia-card>
    <div class="soft-scrollbar flex-1 min-h-0 overflow-y-auto pr-2">
      <elcia-contact-form [form]="form"/>
    </div>
  </elcia-card>

  <elcia-save-bar (onDiscard)="discard()"
                  (onSave)="submit()"
                  [isDirty]="isDirty()"
                  [isInvalid]="isInvalid()"
                  [isSaving]="isSaving()"
                  [saveLabel]="isEditMode() ? 'action.save' : 'action.create'"
                  [savedAt]="savedAt()"/>
</div>
